import { axiosClientAdmin } from "@/lib/auth";
import { Comparator, Filter, FilterOperator, GetSearchMonitoringOfficerShiftsMonitoringData, GetSearchMonitoringOfficerShiftsMonitoringResponse, SortOrder } from "../types.gen";
import { SearchInput, SearchInputBase } from "../util/types"
import { toDate } from "date-fns"
import { UseQueryOptions } from "@tanstack/react-query";

export type SearchCompanyShiftsInput = SearchInputBase & {
  companyId: string;
  officerName?: string,
  startDate?: string | Date,
  endDate?: string | Date
}

export const searchCompanyShifts = async (
  input: SearchCompanyShiftsInput
) => {
  const { companyId, officerName, startDate, endDate, ...rest } = input
  const pathTpl: GetSearchMonitoringOfficerShiftsMonitoringData["url"] = "/Monitoring/users/shifts/search"

  const search = new SearchInput({
    sortBy: "start",
    sortDir: SortOrder.Descending,
    ...rest,
  })

  const ors: Filter[] = []

  if (officerName) {
    ors.push({
      field: "monitoringOfficerName",
      value: officerName,
      action: Comparator.ILike
    })
  }

  if (startDate) {
    ors.push({
      field: "start",
      value: toDate(startDate).toISOString(),
      action: Comparator.GtEq
    })
  }

  if (endDate) {
    ors.push({
      field: "start",
      value: toDate(endDate).toISOString(),
      action: Comparator.LtEq
    })
  }

  if (ors.length > 0) {
    search.filterFilterGroups.push({
      operator: FilterOperator.Or,
      filters: ors
    })
  }

  search.add("monitoringCompanyId", companyId)

  const response = await axiosClientAdmin.get<GetSearchMonitoringOfficerShiftsMonitoringResponse>(
    pathTpl,
    { params: search.toParams() }
  )

  return response.data
}

export const SearchCompanyShiftsQuery = (input: SearchCompanyShiftsInput) => {
  return {
    queryKey: ["monitoring.company.shifts.search", input],
    queryFn: () => searchCompanyShifts(input),
  } satisfies UseQueryOptions
}